import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'
import _imports_2 from '@/assets/float.png'


const _withScopeId = n => (_pushScopeId("data-v-0ca279c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "home-content-loading",
  class: "text-center mt-3"
}
const _hoisted_2 = { class: "fa-2x" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_4 = {
  key: 0,
  id: "home-content"
}
const _hoisted_5 = { id: "grdHome" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"24px","float":"right"},
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { style: {"text-decoration":"line-through"} }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  class: "tooltiptext",
  id: "tooltip"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = {
  id: "filterModel",
  class: "filterPanel d-none"
}
const _hoisted_25 = { class: "p-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, "Filter by: ", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 1,
  id: "home-message",
  class: "text-center mt-3"
}
const _hoisted_30 = { id: "home-message-text" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "care-assignment-container" }, null, -1))
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_CareAssignment = _resolveComponent("CareAssignment")!
  const _component_ExportToExcelForTabs = _resolveComponent("ExportToExcelForTabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_3
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    (_ctx.isShowHomeContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_neu_card, {
              color: "plain-0",
              class: "p-0 m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_table, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table_row, {
                      columns: _ctx.columnHeaders,
                      header: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                          return (_openBlock(), _createBlock(_component_neu_table_heading, {
                            key: column,
                            icon: _ctx.columnIcons[column],
                            slot: column,
                            style: {"padding-top":"25px !important"},
                            onVNeuChange: ($event: any) => (_ctx.sortData($event,column))
                          }, {
                            default: _withCtx(() => [
                              ((column != 'RN Experience' || (column == 'RN Experience' && _ctx.isRNExperienceFeatureEnabled)))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(column) + " ", 1),
                                    (_ctx.filterColumnList.includes(column))
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: ['fas', 'filter'],
                                          size: "lg",
                                          id: "filterIcon",
                                          column: column,
                                          onClick: ($event: any) => (_ctx.onFilterVisible($event, column)),
                                          style: {"margin-left":"5px"}
                                        }, null, 8, ["column", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["icon", "slot", "onVNeuChange"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["columns"]),
                    _createVNode(_component_neu_table_body, { align: "left" }, {
                      default: _withCtx(() => [
                        (_ctx.homeGridData != null && _ctx.homeGridData.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.homeGridData, (dataItem) => {
                              return (_openBlock(), _createBlock(_component_neu_table_row, {
                                columns: _ctx.columnHeaders,
                                slot: _ctx.column,
                                key: dataItem,
                                uid: dataItem.uid,
                                staffId: dataItem.staffId,
                                class: _normalizeClass([dataItem.productiveId == 2 ? 'other-productive': '',
                                           dataItem.productiveId==3 ? 'non-productive' : '' ,
                                           dataItem.productiveId==4 ? 'call-assignment' : '' ,
                                           dataItem.profileCharge && dataItem.charge ? 'chargeAssignment' : '' ,
                                           (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                0) || dataItem.isCancelled) ? 'cancelledAssignment': '',
                                dataItem.origDepartmentId !== dataItem.departmentId && !(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'floatedAssignment' : '']),
                                onClick: ($event: any) => (_ctx.onRowSelect(dataItem))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_label, {
                                    slot: "Name",
                                    title: dataItem.name,
                                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                                (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.homeTabInput.DataSet.DepartmentId === dataItem.origDepartmentId) ? 'strikethrough' : ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.name) + " ", 1),
                                      (dataItem.charge)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: ['fa', 'user-md'],
                                              size: "sm",
                                              style: {"float":"right","font-size":"16px"}
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (dataItem.associationType === _ctx.associationTypes.secondary)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
                                        : _createCommentVNode("", true),
                                      (dataItem.associationType === _ctx.associationTypes.unassociated)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
                                        : _createCommentVNode("", true),
                                      (dataItem.isFloat)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Skill",
                                    title: dataItem.skillLevelDescription,
                                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                                (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.homeTabInput.DataSet.DepartmentId === dataItem.origDepartmentId) ? 'strikethrough' : ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.skillLevelDescription), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Comps",
                                    style: {"white-space":"nowrap"},
                                    class: _normalizeClass(["col-comps", [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.competencyCodes), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Department",
                                    title: dataItem.departmentName,
                                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': ''])
                                  }, {
                                    default: _withCtx(() => [
                                      (dataItem.origDepartmentId !== dataItem.departmentId)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                            _createTextVNode(_toDisplayString(dataItem.departmentName) + " ", 1),
                                            _hoisted_17,
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(dataItem.origDepartmentName), 1)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(dataItem.departmentName), 1))
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Shift",
                                    title: dataItem.shiftCode,
                                    class: _normalizeClass([dataItem.overtimeShift ? 'gridOverTime': '',
                                           (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                    0) || dataItem.isCancelled) ? 'strikethrough': '',
                                    (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.homeTabInput.DataSet.DepartmentId === dataItem.origDepartmentId) ? 'strikethrough' : ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.shiftCode), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Start Time",
                                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                            (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.homeTabInput.DataSet.DepartmentId === dataItem.origDepartmentId) ? 'strikethrough' : ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.actualStartTime)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "End Time",
                                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                            (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.homeTabInput.DataSet.DepartmentId === dataItem.origDepartmentId) ? 'strikethrough' : ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.actualEndTime)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Type",
                                    title: dataItem.employeeType,
                                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                            (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.homeTabInput.DataSet.DepartmentId === dataItem.origDepartmentId) ? 'strikethrough' : ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.employeeType), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "class"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Hours",
                                    title: dataItem.hours,
                                    class: _normalizeClass([dataItem.isOvertime ? 'gridOverTime': ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.hours), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "class"]),
                                  (dataItem.rnExperienceFeatureEnabled)
                                    ? (_openBlock(), _createBlock(_component_neu_label, {
                                        key: 0,
                                        slot: "RN Experience",
                                        class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(dataItem.rnExperience), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_neu_label, { slot: "Hire Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.hireDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Seniority Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.seniorityDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Cancelled" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastCanceledDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Floated" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastFloatedDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Notes" }, {
                                    default: _withCtx(() => [
                                      (dataItem.hasNotes)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                            _createElementVNode("span", {
                                              class: "tooltip",
                                              onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showToolTip($event)))
                                            }, [
                                              _createVNode(_component_font_awesome_icon, {
                                                icon: ['fa', 'sticky-note'],
                                                size: "sm"
                                              }),
                                              _createElementVNode("span", _hoisted_21, [
                                                _createTextVNode("Notes: "),
                                                _hoisted_22,
                                                _createTextVNode(" " + _toDisplayString(_ctx.setGridDateFormat(dataItem.notedate)) + " ", 1),
                                                _hoisted_23,
                                                _createTextVNode(" " + _toDisplayString(dataItem.note.length > 50 ? dataItem.note.replace(' ','').substring(0,50) + "..." : dataItem.note), 1)
                                              ])
                                            ], 32)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["columns", "slot", "uid", "staffId", "class", "onClick"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              (_ctx.filterColumn == 'Hours')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "data-role": "dropdownlist",
                    class: "neu-select mb-2 filterInput",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedNumberFilter) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberFilter, (numFtr) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: numFtr.Id,
                        key: numFtr.Id
                      }, _toDisplayString(numFtr.Value), 9, _hoisted_27))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.selectedNumberFilter]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    "data-role": "dropdownlist",
                    class: "neu-select mb-2 filterInput",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTextFilter) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFilter, (txtFtr) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: txtFtr.Id,
                        key: txtFtr.Id
                      }, _toDisplayString(txtFtr.Value), 9, _hoisted_28))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.selectedTextFilter]
                  ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.filterColumn == 'Hours')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 2,
                    title: "Value",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.NumberfilterText) = $event)),
                    class: "neu-input mb-2 filterInput",
                    type: "number"
                  }, null, 512)), [
                    [_vModelText, _ctx.NumberfilterText]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 3,
                    title: "Value",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterText) = $event)),
                    class: "neu-input mb-2 filterInput",
                    type: "text"
                  }, null, 512)), [
                    [_vModelText, _ctx.filterText]
                  ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "submit",
                  title: "Filter",
                  class: "neu-button--primary neu-button neu-button--raised filterBtn",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onGridFilter && _ctx.onGridFilter(...args)))
                }, "Filter"),
                _createElementVNode("button", {
                  type: "reset",
                  title: "Clear",
                  class: "neu-button--primary neu-button neu-button--raised filterBtn",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClear && _ctx.onGridFilterClear(...args)))
                }, "Clear"),
                _createElementVNode("button", {
                  type: "button",
                  title: "Close",
                  class: "neu-button--primary neu-button neu-button--raised filterBtn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClose && _ctx.onGridFilterClose(...args)))
                }, "Close")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowHomeMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.homeMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_31,
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowCareAssignmentSheetPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode(_component_CareAssignment, {
            onClosePrintTemplate: _ctx.closeCareAssignmentSheetPopup,
            payloadCareAssignment: _ctx.payloadCareAssignment
          }, null, 8, ["onClosePrintTemplate", "payloadCareAssignment"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowExportToExcel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(_component_ExportToExcelForTabs, {
            onCloseExcelTemplate: _ctx.closeHomeTabExportToExcel,
            payloadExportToExcel: _ctx.payloadExportToExcel
          }, null, 8, ["onCloseExcelTemplate", "payloadExportToExcel"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}